import { render, staticRenderFns } from "./politique_confidentialite.vue?vue&type=template&id=7e79947c&"
import script from "./politique_confidentialite.vue?vue&type=script&lang=js&"
export * from "./politique_confidentialite.vue?vue&type=script&lang=js&"
import style0 from "./politique_confidentialite.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports